<template>
  <div class="development">
    <Interface></Interface>
  </div>
</template>

<script>
import Interface from "@/views/Interface.vue";
import { getCookie } from "../common/utils";
export default {
  components: {
    Interface,
  },
  data() {
    return {
      isShow: true,
      networkShow: false,
    };
  },
  mounted() {
    const network = getCookie("network");
    if (network == 1) {
      this.networkShow = true;
    } else {
      this.networkShow = false;
    }
  },
};
</script>

<style lang="less">
.development {
  height: 100%;
  .interface {
    height: 100%;
    .el-container {
      height: 100%;
      .el-aside {
        height: calc(100%);
        .menu {
          height: calc(100%);
          overflow: auto;
        }
      }
      .el-main {
        height: 100%;
        background-color: #fff;
      }
    }
  }
  .el-tabs__item {
    color: black !important;
  }

  .el-tabs__item.is-active {
    color: rgb(50, 50, 159) !important;
  }

  .el-tabs__nav-wrap::after {
    width: 100% !important;
    left: 0 !important;
    background-color: #e4e7ed !important;
  }

  .el-tabs__nav-scroll {
    display: flex;
    justify-content: flex-start;
  }

  .el-tabs__header {
    margin: 0;
  }

  .el-tab-pane {
    height: calc(100vh - 125px);
    font-size: 16px;
  }
}
</style>
